import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { EmergencyContact } from './emergency-contact';
export { EmergencyContact };
import { emergencyContactSchema } from '@schemas/business-objects/emergency-contact';
import { CandidateFormGroup } from './candidate-form-group';

export class EmergencyContactFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    name: SchemaFormControl;
    phoneNumber: SchemaFormControl;
    relationship: SchemaFormControl;
    candidateId: SchemaFormControl;
    candidate: CandidateFormGroup;
  };

  declare value: Partial<EmergencyContact>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(emergencyContactSchema, EmergencyContact, data, options);
  }

  get object(): EmergencyContact {
    return new EmergencyContact(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'candidate':
        return new CandidateFormGroup();
      default:
        return undefined;
    }
  }
}

export class EmergencyContactFormArray extends PersistedFormArray {
  readonly entityName = 'EmergencyContact' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(emergencyContactSchema, EmergencyContact, options);
  }

  protected override createItemGroup() {
    return new EmergencyContactFormGroup();
  }

  get array(): EmergencyContact[] {
    return this.controls.map(
      (group: EmergencyContactFormGroup) => group.object,
    );
  }
}

export class EmergencyContactPersistedArray extends PersistedArray<EmergencyContact> {
  readonly entityName = 'EmergencyContact' as const;

  constructor(options?: PersistedArrayOptions) {
    super(EmergencyContact, options);
  }
}
